<template>
  <div class="NoDataFound">
    <div class="text-center no-data-container">
      {{ noDataContent && noDataContent.length ? noDataContent : 'No data available' }}
    </div>
  </div>
</template>
<script>
export default {
  props: ['noDataContent'],
  name: 'NoDataFound',
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.NoDataFound {
  padding: 0px 0 0 0;
}
.no-data-container {
  max-width: 300px;
  border: 1px solid $secondary-theme-color;
  padding: 8px;
  margin: 50px auto;
  color: $secondary-theme-color;
  font-size: 13px;
  font-weight: 300;
  // width: 300px;
  border-radius: 6px;
}
</style>
